import { trpc } from '@/shared/api';

/**
 * 기획전 하나(exhibitions.get) — 상품 목록의 기획전 띠 이름을 받는다.
 * 숨김·삭제·공개 상품 0 은 모두 NOT_FOUND 로 온다 — 재시도해도 결과가 같아
 * 전역 기본값(retry: 1)을 끈다(use-store-product-detail-query 와 같은 패턴).
 */
export const useExhibitionQuery = (exhibitionId: string | undefined) =>
  trpc.exhibitions.get.useQuery(
    // 조건이 없으면 요청하지 않는다 — 빈 문자열은 쿼리 키 자리만 채운다.
    { id: exhibitionId ?? '' },
    { enabled: exhibitionId !== undefined, retry: false },
  );
